import {useLocation as location2} from 'wouter';
import cn from 'classnames';
export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

export const VerCarrito=(props)=>{
    const [location, navigate] = location2();
    const cart=JSON.parse(localStorage.getItem('cart')) || [];

    if(cart.length>0){
        return (
            <button 
                    className={cn("fixed translate-x-[-50%] bottom-[100px] left-[50%]  z-50  bg-primary-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-primary-700 transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2",props.hasTabNav?'':'bottom-[50px]')}
                    onClick={()=>{
                    navigate('/cart');
                }}>
                <span className="material-symbols-outlined">shopping_cart</span>
                Ver carrito ({cart.length})
            </button>
        );
    }else{
        return null;
    }
}

export const toPesos=function(n){
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    return Number(n).toLocaleString('en', options);  
}